import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./pages/Navbar";
import Login from "./pages/Login";
import Register from "./pages/Register";
import OAuthSuccess from "./pages/OAuthSuccess";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./pages/ProtectedRoute";
import ResetPassword from "./pages/ResetPassword";
import ForgotPassword from "./pages/ForgotPassword";
import VerifyEmailSent from "./pages/VerifyEmailSent";
import VerifyEmail from "./pages/VerifyEmail";
import ManageAccount from "./pages/ManageAccount";
import Pricing from "./pages/Pricing";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Callback from "./pages/Callback";
import Footer from "./pages/Footer";
import { Analytics } from "./pages/Analytics";

export default function App() {
  return (
    <AuthProvider>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-1">
          <Routes>
            {/* Core General Route */}
            <Route path="/" element={<Dashboard pageType="default" />} />

            {/* Detector Specific SEO Routes */}
            <Route path="/bypass-turnitin" element={<Dashboard pageType="detector" pageKey="turnitin" />} />
            <Route path="/bypass-gptzero" element={<Dashboard pageType="detector" pageKey="gptzero" />} />
            <Route path="/bypass-copyleaks" element={<Dashboard pageType="detector" pageKey="copyleaks" />} />
            <Route path="/ai-humaniser" element={<Dashboard pageType="detector" pageKey="ai-humaniser" />} />
            <Route path="/ai-humanizer" element={<Dashboard pageType="detector" pageKey="ai-humanizer" />} />
            <Route path="/ai-bypasser" element={<Dashboard pageType="detector" pageKey="ai-bypasser" />} />
            <Route path="/bypass-ai-detection" element={<Dashboard pageType="detector" pageKey="bypass-ai-detection" />} />
            <Route path="/ai-detection-remover" element={<Dashboard pageType="detector" pageKey="ai-detection-remover" />} />
            <Route path="/best-ai-humanizer-for-students" element={<Dashboard pageType="detector" pageKey="best-ai-humanizer-for-students" />} />

            {/* Competitor Alternative Comparison Routes */}
            <Route path="/alternatives/stealthwriter" element={<Dashboard pageType="competitor" pageKey="stealthwriter" />} />
            <Route path="/alternatives/undetectable-ai" element={<Dashboard pageType="competitor" pageKey="undetectable-ai" />} />

            {/* Private: Only logged-in users */}
            <Route element={<ProtectedRoute />}>
              <Route path="/account" element={<ManageAccount />} />
            </Route>

            {/* Auth flows */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email-sent" element={<VerifyEmailSent />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/oauth-success" element={<OAuthSuccess />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/callback" element={<Callback />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </AuthProvider>
  );
}